
import http from '../../api/http';


export async function loginWithEmailPassword(payload) {
  const response = await http.post('/auth/login', payload);
  return response.data;
}



export async function bootstrapAdmin(payload) {
  const response = await http.post('/auth/bootstrap-admin', payload);
  return response.data;
}

export async function requestPasswordReset(payload) {
  const response = await http.post('/auth/forgot-password', payload);
  return response.data;
}

export async function resetPassword(payload) {
  const response = await http.post('/auth/reset-password', payload);
  return response.data;
}

export async function acceptInvite(payload) {
  const response = await http.post('/auth/accept-invite', payload);
  return response.data;
}

export async function createInvite(payload) {
  const response = await http.post('/auth/invite', payload);
  return response.data;
}




export async function getCurrentSessionUser() {
  const response = await http.get('/auth/me');
  return response.data;
}

export async function updateMyPreferences(payload) {
  const response = await http.patch('/auth/me/preferences', payload);
  return response.data;
}

export async function listMyNotifications(params = {}) {
  const response = await http.get('/auth/me/notifications', { params });
  return response.data;
}

export async function markMyNotificationsSeen() {
  const response = await http.patch('/auth/me/notifications/seen');
  return response.data;
}

export async function updateMyNotificationItemState(payload) {
  const response = await http.patch('/auth/me/notifications/item-state', payload);
  return response.data;
}

export async function listMyMessages(params = {}) {
  const response = await http.get('/auth/me/messages', { params });
  return response.data;
}

export async function markMyMessagesSeen() {
  const response = await http.patch('/auth/me/messages/seen');
  return response.data;
}

export async function updateMyMessageItemState(payload) {
  const response = await http.patch('/auth/me/messages/item-state', payload);
  return response.data;
}


export async function listUsers() {
  const response = await http.get('/auth/users');
  return response.data;
}

export async function updateUser(userId, payload) {
  const response = await http.patch(`/auth/users/${userId}`, payload);
  return response.data;
}
